import {
  CreateGHADiscountRuleBody,
  GHADiscountRule,
  GHADiscountRuleAccountType,
} from '~/services/ConnectionGoogleService';
import { formatDateWithClock } from '~/services/TimeService';

import { GHA_DISCOUNT_ACCOUNT_TYPE_OPTIONS } from './constants';

export type GHADiscountRuleFormState = {
  propertyId: string;
  accountType?: GHADiscountRuleAccountType;
  discountValue: string;
  minAdvanceBookingWindow: string;
  minLengthOfStay: string;
};

export function toCreateGHADiscountRuleBody(
  form: GHADiscountRuleFormState & { accountType: GHADiscountRuleAccountType },
): CreateGHADiscountRuleBody {
  return {
    propertyId: form.propertyId.trim(),
    accountType: form.accountType,
    discountValue: Number(form.discountValue),
    minAdvanceBookingWindow: Number(form.minAdvanceBookingWindow),
    minLengthOfStay: Number(form.minLengthOfStay),
  };
}

export function formatDiscountAccountType(value: string) {
  return GHA_DISCOUNT_ACCOUNT_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? value;
}

export function formatRuleDiscount(rule: GHADiscountRule) {
  return `${rule.discountValue}%`;
}

export function formatDateTime(value?: string | null) {
  return value ? formatDateWithClock(value) : '-';
}
